$('body').on('click', '.delete-pending-application-trigger', function() {
    var data = $(this).parents('.application');
    $('.delete-pending-application form').attr('action', $('.delete-pending-application form').attr('data-action')+data.attr('data-application'));
    openModal('.delete-pending-application');
    return false;
});

$('body').on('submit', '.delete-pending-application form', function() {
    var $this = $(this);
    var fields = $this.serializeArray();
    fields[fields.length] = { name: '_token', value: $('meta[name="csrf-token"]').attr('content') };
    
    loading();
    $.ajax({
        type : 'POST',
        url : $this.attr('action'),
        data : fields,
        dataType : 'json',
        success : function(data) {
            console.log(data);
            unloading();

            if(!data.success) {
                showError('Error', data.message);
                return false;
            }

            $('.application[data-application="'+data.application+'"]').remove();
            $('[data-input="total_deposit_parsed"]').html(data.total_deposit_parsed);

			closeModal();
			addNotification(data.notification.title, data.notification.message, data.notification.icon);
        },
        error : function(request) {
            console.log(request.responseText);
        }
    });

    return false;
});

$('body').on('change', '.deposit-payment input[name="payment_option"]', function() {
    var method = $(this).val();
    if(method === 'saved') {
    	$('input[name="card"]').val('');
    	$('.select-saved-card-trigger').removeClass('active');
    	$('.payment-method[data-method="saved"]').removeClass('hidden');
    	$('.payment-method[data-method="saved"] input').each(function() {
    		var input = $(this);
    		input.prop('disabled', false);
    		if(input.attr('data-required')) {
    			input.addClass('required');
    		}
    	});
    	$('.payment-method[data-method="new"]').addClass('hidden');
    	$('.payment-method[data-method="new"] input').each(function() {
			var input = $(this);
    		input.prop('disabled', true);
			input.removeClass('required');
    	});
    	return;
    }

    if(method === 'new') {
    	$('input[name="card"]').val('');
    	$('.select-saved-card-trigger').removeClass('active');
    	$('.payment-method[data-method="new"]').removeClass('hidden');
    	$('.payment-method[data-method="new"] input').each(function() {
    		var input = $(this);
    		input.prop('disabled', false);
    		if(input.attr('data-required')) {
    			input.addClass('required');
    		}
    	});
    	$('.payment-method[data-method="saved"]').addClass('hidden');
    	$('.payment-method[data-method="saved"] input').each(function() {
			var input = $(this);
    		input.prop('disabled', true);
			input.removeClass('required');
    	});
    	return;
    }
});

$('body').on('click', '.deposit-payment .select-saved-card-trigger', function() {
    $('.select-saved-card-trigger').removeClass('active');
    var $this = $(this);
    $this.addClass('active');
    $('input[name="card"]').val($this.attr('data-card'));
    return false;
});

$('body').on('submit', '.deposit-payment form', function() {
    var $this = $(this);
    var form = $this.parents('.deposit-payment');
    var fields = $this.serializeArray();
    fields[fields.length] = { name: '_token', value: $('meta[name="csrf-token"]').attr('content') };
    
    var error = false;

    form.find('.required').each(function() {
        if($(this).val() === '') {
            error = true;
        }
    });

    if(error) {
        showError('Error', 'Please fill out all required fields');
        return false;
    }
    
    loading();
    $.ajax({
        type : 'POST',
        url : $this.attr('action'),
        data : fields,
        dataType : 'json',
        success : function(data) {
            console.log(data);
            unloading();
            closeModal();
            showError(data.success ? 'Success' : 'Error', data.message);
        },
        error : function(request) {
            console.log(request.responseText);
        }
    });

    return false;
});